module.exports = __webpack_public_path__ + "static/media/11.118a6946.png";